import {
  RapidGrowthIcon2,
  ImpactIcon2,
  EngagementIcon2,
} from "@/components/Icons";

const CommunityHighlights = () => {
  const communityHighlightsItems = [
    {
      icon: (
        <RapidGrowthIcon2 className="w-10 h-10 text-white bg-red-600 rounded-full p-2" />
      ),
      name: "Rapid Growth",
      description:
        "Expanded from 40 members in January 2025 to over 300 active online members.",
    },
    {
      icon: (
        <EngagementIcon2 className="w-10 h-10 text-white bg-red-600 rounded-full p-2" />
      ),
      name: "Engagement",
      description: "High participation rates in events and projects.",
    },
    {
      icon: (
        <ImpactIcon2 className="w-10 h-10 text-white bg-red-600 rounded-full p-2" />
      ),
      name: "Impact",
      description:
        "Members have successfully transitioned into tech roles and launched startups.",
    },
  ];

  return (
    <section className="bg-secondary py-16 px-6 lg:px-14">
      <div className="text-center mb-12">
        <h1 className="text-primary font-bold text-3xl sm:text-4xl leading-snug uppercase">
          Community Highlights
        </h1>
      </div>
      <div className="grid gap-12 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 max-w-7xl mx-auto">
        {communityHighlightsItems.map((item, index) => (
          <div
            key={index}
            className="flex flex-col items-center text-center space-y-4 px-4"
          >
            {item.icon}
            <h3 className="text-lg font-semibold text-red-700 uppercase">
              {item.name}
            </h3>
            <p className="text-gray-700">{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CommunityHighlights;
